export const getResponseModel = () => ({
    Code: 0,
    Message: "",
    Result: null,
});
